//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    list: {
      type: Array,
    },
    dance: {
      type: String,
    },
  },
  data() {
    return {
      levelName: ["Newcomer", "Bronze", "Silver", "Gold"],
    };
  },
};
